import React from "react";
import NestedRoutes from "../components/NestedRoutes";

export default (routes) => () => <NestedRoutes routes={routes} />;
